import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {object} from 'prop-types'
import {useSelector} from 'react-redux'

export enum PageTabEnum {
  pk = 0,
  list = 1,
}
// https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=27705081
interface familyPkHomepageArg {
  tab: PageTabEnum
  title_offset: InitialStateType['title_offset']
}
export const familyPkHomepage = createAsyncThunk(
  '/live/pk/family_pk_homepage',
  async (arg: familyPkHomepageArg, store) => {
    const resp = await http.post<HiyaRes<Omit<InitialStateType, ''>>>(
      '/live/pk/family_pk_homepage',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return {
      ...resp.data.data,
      PageTabIndex: arg.tab,
    }
  }
)

// https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=27705773
export const updateFamilyPkApply = createAsyncThunk(
  '/live/pk/update_family_pk_apply',
  async (param: {status: 0 | 1; pk_room_id: number}, store) => {
    const resp = await http.post<HiyaRes<any>>(
      '/live/pk/update_family_pk_apply',
      {
        ...store.getState().env.deviceinfo,
        ...param,
      },
      {
        xcErrorToast: true,
      }
    )
    return param.status
  }
)
export const open = createAsyncThunk(
  '/live/pk/get_rank_scheme',
  async (family_id: number, store) => {
    const resp = await http.post<
      HiyaRes<{
        scheme: string
      }>
    >('/live/pk/get_rank_scheme', {
      ...store.getState().env.deviceinfo,
      family_id,
    })
    return resp.data.data
  }
)

export interface getContributionListArg {
  family_id: number
  tab: PageTabEnum
  title_offset: InitialStateType['title_offset']
}
export const getContributionList = createAsyncThunk(
  '/live/pk/get_contribution_list',
  async (arg: getContributionListArg, store) => {
    const resp = await http.post<
      HiyaRes<{
        contribution_list: InitialStateType['own']['contribution_list']
      }>
    >('/live/pk/get_contribution_list', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)
export interface familyPkRewardRet {
  list: Array<{
    over_all_ranking: string
    reward_list: Array<Reward>
  }>
}
export const familyPkReward = createAsyncThunk(
  '/live/pk/family_pk_reward',
  async (arg, store) => {
    const resp = await http.post<HiyaRes<familyPkRewardRet>>(
      '/live/pk/family_pk_reward',
      store.getState().env.deviceinfo
    )
    return resp.data.data
  }
)

interface Reward {
  icon: string
  desc: string
  season: number
}
export interface InitialStateType {
  // 当前tab
  PageTabIndex: PageTabEnum
  // 区域限制
  area_limit?: boolean
  // 标题偏移量 用于查看历史
  title?: string
  title_offset?: number
  left_more?: boolean
  right_more?: boolean
  reward?: Reward[]
  // 报名按钮状态
  sign_up_status?: 0 | 1 | 2
  in_pk?: boolean
  // 倒计时
  count_down?: number
  // pk 开始结束时间
  start_time?: string
  end_time?: string
  // 是否是冷启阶段
  pre_status?: boolean
  // 每日赛况返回类型： 0:报名列表 1:正在pk中列表
  typ?: 0 | 1
  // 报名列表
  sign_up_list?: Array<{
    family_id: number
    avatar: string
    name: string
  }>
  pk_list?: Array<{
    family_id: number
    avatar: string
    name: string
    score: number
    t_family_id: number
    t_avatar: string
    t_name: string
    t_score: number
  }>
  rank_list?: Array<{
    family_id: number
    avatar: string
    name: string
    score: number
    rank: number
  }>
  own?: {
    family_id: number
    avatar: string
    name: string
    score: number
    rank: number
    contribution_list: Array<{
      mid: number
      avatar: string
      name: string
      score: number
      rank: number
    }>
  }
  // 当前人的身份，报名埋点需要
  role?: number
  default_pk_room?: number
  // 奖励
  Rewardlist?: familyPkRewardRet['list']
}

const initialState: InitialStateType = {
  PageTabIndex: PageTabEnum.pk,
}

export const FamilyPkSlice = createSlice({
  name: 'Animal_Penguin',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(familyPkHomepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(updateFamilyPkApply.fulfilled, (state, action) => {
      const map = {
        1: () => {
          return {
            sign_up_list: [
              {
                family_id: state.own.family_id,
                avatar: state.own.avatar,
                name: state.own.name,
              },
              ...state.sign_up_list,
            ],
            sign_up_status: 2,
          }
        },
        0: () => {
          return {
            sign_up_list: state.sign_up_list.filter(
              (v) => v.family_id !== state.own.family_id
            ),
            sign_up_status: 1,
          }
        },
      }
      Object.assign(state, map[action.payload]())
    })
    builder.addCase(open.fulfilled, (state, action) => {
      window.HiyaJSBridge.callHandler('openScheme', {
        url: action.payload.scheme,
      })
    })
    builder.addCase(familyPkReward.fulfilled, (state, action) => {
      Object.assign(state, {
        Rewardlist: action.payload.list,
      })
    })
  },
})
export default FamilyPkSlice.reducer
export const useFamilyPkState = () => {
  const data = useSelector((state) => state.Animal_Penguin)
  return data
}
